import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Meeting {
  _id?: string;
  topic?: string;
  start_time?: string;
  end_time?: string;
  duration?: number;
  status?: string;
  meetingStatus?: string;
  meetingId?: string;
  groupId?: any;
  attendanceData?: any[];
}

interface MeetingState {
  pageIndex: number;
  size: number;
  data: {
    meetings: Meeting[];
    count: number;
  } | null;
}



const initialState: MeetingState = {
  pageIndex: 1,
  size: 10,
  data: null
};

const meetingHistorySlice = createSlice({
  name: 'meetingHistory',
  initialState,
  reducers: {
    setMeetingPageIndex(state, action: PayloadAction<number>) {
      state.pageIndex = action.payload;
    },
    setMeetingTableSize(state, action: PayloadAction<number>) {
      state.size = action.payload;
    },
    updateMeetingHistory: (state, action: PayloadAction<{ count: number; meetings: any[] }>) => {
      state.data = {
        count: action.payload.count,
        meetings: action.payload.meetings
      };
    }
  }
});
 console.log()
export const { setMeetingPageIndex, setMeetingTableSize, updateMeetingHistory } = meetingHistorySlice.actions;
export default meetingHistorySlice.reducer;